import { usePage } from "@/lib/hooks";
import SectionRenderer from "@/components/sections/SectionRenderer";

export default function Home() {
  const { data, isLoading } = usePage("home");
  if (isLoading) {
    return (
      <div className="max-w-7xl mx-auto px-4 py-24 space-y-6">
        <div className="h-64 bg-white border border-slate-200 rounded-2xl animate-pulse" />
        <div className="h-40 bg-white border border-slate-200 rounded-2xl animate-pulse" />
      </div>
    );
  }
  return (
    <div data-testid="home-page">
      <SectionRenderer sections={data?.sections || []} />
    </div>
  );
}
